import { createSelector } from '@ngrx/store';

import { VistaUsuarioState, selectVistaUsuario } from '../../vista-usuario/vista-usuario.state';
import { EntityUserState, entityUserAdapter } from './entity-usuario.state';

const { selectAll, selectEntities } = entityUserAdapter.getSelectors();

export const getError = (state: EntityUserState): any => state.error;

export const getIsLoading = (state: EntityUserState): boolean => state.isLoading;

export const getHasAddedSuccess = (state: EntityUserState): boolean => state.hasAddedSuccess;

export const selectEntityUserState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.user
);

export const selectAllUser = createSelector(selectEntityUserState, selectAll);

export const selectAllEntityUser = createSelector(selectEntityUserState, selectAll);

export const selectEntityMaquinaMovil = createSelector(
  selectEntityUserState,
  selectEntities
);
export const selectUsuarioIsLoading = createSelector(
  selectEntityUserState,
  getIsLoading
);

export const selectUsuario = createSelector(
  selectAllUser,
  (usuarios) => usuarios[0]
)


